import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggle = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', toggle, { passive: true });
    return () => window.removeEventListener('scroll', toggle);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="返回顶部"
      className="fixed bottom-8 right-8 z-50 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 cursor-pointer transition-all duration-300 hover:bg-primary-600 active:scale-95"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}